<template>
  <div class="dashboard-page">
    <!-- 顶部核心指标卡片 -->
    <div class="kpi-row">
      <div v-for="(item, index) in kpiList" :key="index" class="kpi-card">
        <div class="kpi-icon" :style="{ color: item.color }">{{ item.icon }}</div>
        <div class="kpi-info">
          <div class="kpi-label">{{ item.label }}</div>
          <div class="kpi-value" :style="{ color: item.color }">{{ item.value }}</div>
          <div class="kpi-trend" :class="{ up: item.trend > 0, down: item.trend < 0 }">
            {{ item.trend > 0 ? '↑' : '↓' }} {{ Math.abs(item.trend) }}%
          </div>
        </div>
      </div>
    </div>

    <!-- 图表区域：第一行 -->
    <div class="chart-row">
      <div class="chart-box chart-large">
        <div class="chart-header">
          <span class="chart-title">◈ 年度采购金额趋势</span>
          <span class="chart-sub">单位：万元</span>
        </div>
        <div ref="chartTrend" class="chart-body"></div>
      </div>
      <div class="chart-box chart-small">
        <div class="chart-header">
          <span class="chart-title">◉ 供应商等级分布</span>
        </div>
        <div ref="chartGrade" class="chart-body"></div>
      </div>
    </div>

    <!-- 图表区域：第二行 -->
    <div class="chart-row">
      <div class="chart-box chart-medium">
        <div class="chart-header">
          <span class="chart-title">▣ 各品类采购占比</span>
        </div>
        <div ref="chartCategory" class="chart-body"></div>
      </div>
      <div class="chart-box chart-medium">
        <div class="chart-header">
          <span class="chart-title">◆ 供应商绩效评分 TOP10</span>
        </div>
        <div ref="chartRank" class="chart-body"></div>
      </div>
    </div>

    <!-- 底部实时动态 -->
    <div class="bottom-row">
      <div class="chart-box chart-full">
        <div class="chart-header">
          <span class="chart-title">◊ 实时采购动态</span>
          <span class="live-dot"></span>
        </div>
        <div class="dynamic-list">
          <div v-for="(log, idx) in dynamicLogs" :key="idx" class="log-item">
            <span class="log-time">{{ log.time }}</span>
            <span class="log-tag" :class="log.type">{{ log.tag }}</span>
            <span class="log-text">{{ log.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SrmDashboard',
  data() {
    return {
      kpiList: [
        { icon: '◈', label: '年度采购总额', value: '¥12.86亿', trend: 15.3, color: '#00d4ff' },
        { icon: '◉', label: '注册供应商数', value: '1,248家', trend: 8.7, color: '#00e5a0' },
        { icon: '▣', label: '在履约合同', value: '386份', trend: -2.1, color: '#f0a030' },
        { icon: '▤', label: '本月订单数', value: '2,156笔', trend: 23.5, color: '#ff6b9d' },
        { icon: '◆', label: '平均绩效分', value: '87.6分', trend: 4.2, color: '#a855f7' },
        { icon: '◊', label: '待协同事项', value: '34项', trend: -12.8, color: '#ff6b6b' }
      ],
      dynamicLogs: [
        { time: '11:28:15', tag: '订单', type: 'order', text: '深圳华强电子 提交新采购订单 #PO-20260625-0892' },
        { time: '11:25:42', tag: '审批', type: 'audit', text: '苏州精密制造 资质审核已通过，评级A级' },
        { time: '11:22:08', tag: '合同', type: 'contract', text: '上海新材料科技 签署年度框架协议，金额¥860万' },
        { time: '11:18:33', tag: '预警', type: 'warn', text: '广州五金制品 交付延迟风险，建议关注' },
        { time: '11:15:56', tag: '订单', type: 'order', text: '北京自动化设备 订单 #PO-20260625-0891 已确认收货' },
        { time: '11:12:21', tag: '绩效', type: 'perf', text: '月度绩效评估完成，32家供应商评级调整' },
        { time: '11:08:47', tag: '审批', type: 'audit', text: '杭州半导体 新供应商准入申请待审批' },
        { time: '11:05:13', tag: '合同', type: 'contract', text: '武汉精密模具 合同续签提醒，剩余7天' }
      ],
      charts: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initTrendChart()
      this.initGradeChart()
      this.initCategoryChart()
      this.initRankChart()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.charts).forEach(chart => chart && chart.dispose())
  },
  methods: {
    handleResize() {
      Object.values(this.charts).forEach(chart => chart && chart.resize())
    },

    // 年度采购金额趋势（折线图 + 面积）
    initTrendChart() {
      const chart = this.$echarts.init(this.$refs.chartTrend)
      this.charts.trend = chart

      const months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      const data2025 = [8200, 9320, 9010, 9340, 12900, 13300, 13200, 12500, 11800, 10200, 9800, 10500]
      const data2026 = [9500, 10500, 11200, 10800, 14200, 15100, null, null, null, null, null, null]

      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          axisPointer: { lineStyle: { color: 'rgba(0, 212, 255, 0.3)' } }
        },
        legend: {
          data: ['2025年', '2026年'],
          textStyle: { color: '#8c9bb3' },
          right: 10,
          top: 0
        },
        grid: { left: 50, right: 20, top: 40, bottom: 25 },
        xAxis: {
          type: 'category',
          data: months,
          axisLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.2)' } },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        series: [
          {
            name: '2025年',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { color: 'rgba(140, 155, 179, 0.5)', width: 2 },
            areaStyle: { color: 'rgba(140, 155, 179, 0.05)' },
            data: data2025
          },
          {
            name: '2026年',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#00d4ff', width: 3 },
            itemStyle: { color: '#00d4ff', borderColor: '#fff', borderWidth: 1 },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 212, 255, 0.3)' },
                { offset: 1, color: 'rgba(0, 212, 255, 0)' }
              ])
            },
            data: data2026
          }
        ]
      })
    },

    // 供应商等级分布（环形图）
    initGradeChart() {
      const chart = this.$echarts.init(this.$refs.chartGrade)
      this.charts.grade = chart

      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' }
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: { color: '#8c9bb3', fontSize: 11 },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['35%', '50%'],
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: false },
            data: [
              { value: 86, name: '战略级', itemStyle: { color: '#00d4ff' } },
              { value: 142, name: '核心级', itemStyle: { color: '#00e5a0' } },
              { value: 328, name: '优选级', itemStyle: { color: '#f0a030' } },
              { value: 512, name: '合格级', itemStyle: { color: '#8c9bb3' } },
              { value: 180, name: '观察级', itemStyle: { color: '#ff6b6b' } }
            ]
          }
        ]
      })
    },

    // 各品类采购占比（玫瑰图）
    initCategoryChart() {
      const chart = this.$echarts.init(this.$refs.chartCategory)
      this.charts.category = chart

      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' }
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          textStyle: { color: '#8c9bb3', fontSize: 11 },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [
          {
            type: 'pie',
            radius: [20, 90],
            center: ['50%', '45%'],
            roseType: 'area',
            label: {
              color: '#8c9bb3',
              fontSize: 11,
              formatter: '{b}\n{d}%'
            },
            labelLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.3)' } },
            data: [
              { value: 35, name: '电子元器件', itemStyle: { color: '#00d4ff' } },
              { value: 28, name: '机械加工', itemStyle: { color: '#00e5a0' } },
              { value: 22, name: '化工材料', itemStyle: { color: '#f0a030' } },
              { value: 18, name: '包装材料', itemStyle: { color: '#ff6b9d' } },
              { value: 15, name: '物流运输', itemStyle: { color: '#a855f7' } },
              { value: 12, name: '办公用品', itemStyle: { color: '#8c9bb3' } }
            ]
          }
        ]
      })
    },

    // 供应商绩效评分 TOP10（横向条形图）
    initRankChart() {
      const chart = this.$echarts.init(this.$refs.chartRank)
      this.charts.rank = chart

      const suppliers = ['深圳华强电子', '苏州精密制造', '上海新材料科技', '北京自动化设备', '杭州半导体',
                         '武汉精密模具', '成都光电技术', '南京智能装备', '东莞金属制品', '青岛化工集团']
      const scores = [96.5, 94.2, 92.8, 91.5, 89.6, 88.3, 87.1, 85.9, 84.2, 82.7]

      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(1, 16, 57, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.3)',
          textStyle: { color: '#fff' },
          axisPointer: { type: 'shadow', shadowStyle: { color: 'rgba(0, 212, 255, 0.1)' } }
        },
        grid: { left: 100, right: 40, top: 10, bottom: 10 },
        xAxis: {
          type: 'value',
          max: 100,
          axisLine: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 10 },
          splitLine: { lineStyle: { color: 'rgba(140, 155, 179, 0.1)' } }
        },
        yAxis: {
          type: 'category',
          data: suppliers,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#8c9bb3', fontSize: 11 }
        },
        series: [
          {
            type: 'bar',
            barWidth: 14,
            data: scores.map((score, idx) => ({
              value: score,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: idx < 3 ? '#00d4ff' : '#00e5a0' },
                  { offset: 1, color: idx < 3 ? '#00e5a0' : 'rgba(0, 229, 160, 0.3)' }
                ]),
                borderRadius: [0, 7, 7, 0]
              }
            })),
            label: {
              show: true,
              position: 'right',
              color: '#fff',
              fontSize: 11,
              formatter: '{c}'
            }
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-page {
  width: 100%;
  min-height: 100%;
  padding-bottom: 20px;
}

/* ==================== KPI 卡片行 ==================== */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.kpi-card {
  background: rgba(0, 212, 255, 0.04);
  border: 1px solid rgba(0, 212, 255, 0.12);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.08);
    border-color: rgba(0, 212, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 212, 255, 0.1);
  }
}

.kpi-icon {
  font-size: 28px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 212, 255, 0.06);
  border-radius: 10px;
  flex-shrink: 0;
}

.kpi-info {
  flex: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 12px;
  color: #8c9bb3;
  margin-bottom: 4px;
}

.kpi-value {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
  letter-spacing: 1px;
}

.kpi-trend {
  font-size: 11px;

  &.up {
    color: #00e5a0;
  }

  &.down {
    color: #ff6b6b;
  }
}

/* ==================== 图表行 ==================== */
.chart-row {
  display: grid;
  gap: 16px;
  margin-bottom: 16px;

  &:nth-of-type(2) {
    grid-template-columns: 2fr 1fr;
  }

  &:nth-of-type(3) {
    grid-template-columns: 1fr 1fr;
  }
}

.chart-box {
  background: rgba(0, 212, 255, 0.03);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.chart-title {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
}

.chart-sub {
  font-size: 11px;
  color: #8c9bb3;
}

.chart-body {
  flex: 1;
  min-height: 240px;
}

/* ==================== 底部动态行 ==================== */
.bottom-row {
  margin-bottom: 16px;
}

.chart-full {
  min-height: 200px;
}

.live-dot {
  width: 8px;
  height: 8px;
  background: #ff6b6b;
  border-radius: 50%;
  position: relative;
  animation: liveBlink 1.5s infinite;

  &::after {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    width: 16px;
    height: 16px;
    border: 1px solid rgba(255, 107, 107, 0.5);
    border-radius: 50%;
    animation: liveRipple 1.5s infinite;
  }
}

@keyframes liveBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

@keyframes liveRipple {
  0% { transform: scale(0.5); opacity: 1; }
  100% { transform: scale(1.5); opacity: 0; }
}

/* ==================== 动态列表 ==================== */
.dynamic-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.log-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(0, 212, 255, 0.03);
  border-radius: 6px;
  border-left: 2px solid rgba(0, 212, 255, 0.2);
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 212, 255, 0.06);
    border-left-color: #00d4ff;
  }
}

.log-time {
  font-size: 12px;
  color: #8c9bb3;
  font-family: 'Courier New', monospace;
  flex-shrink: 0;
  width: 72px;
}

.log-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  flex-shrink: 0;
  font-weight: bold;

  &.order {
    background: rgba(0, 212, 255, 0.15);
    color: #00d4ff;
  }

  &.audit {
    background: rgba(0, 229, 160, 0.15);
    color: #00e5a0;
  }

  &.contract {
    background: rgba(240, 160, 48, 0.15);
    color: #f0a030;
  }

  &.warn {
    background: rgba(255, 107, 107, 0.15);
    color: #ff6b6b;
  }

  &.perf {
    background: rgba(168, 85, 247, 0.15);
    color: #a855f7;
  }
}

.log-text {
  font-size: 13px;
  color: #c8d4e8;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ==================== 响应式 ==================== */
@media (max-width: 1400px) {
  .kpi-row {
    grid-template-columns: repeat(3, 1fr);
  }

  .chart-row:nth-of-type(2),
  .chart-row:nth-of-type(3) {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .kpi-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .chart-body {
    min-height: 200px;
  }

  .log-item {
    flex-wrap: wrap;
    gap: 6px;
  }

  .log-text {
    width: 100%;
    white-space: normal;
  }
}
</style>